import React, { useEffect, useState } from "react";
import { Card, Button } from "react-bootstrap";
import { FaClipboard, FaDownload, FaFileAlt } from "react-icons/fa";
import "../styles/LastUploadedFile.css";

const LastUploadedFile = ({ fileName, shareLink, onShareClick, isDark, expiresIn }) => {

  const [remainingSec, setRemainingSec] = useState(expiresIn * 60);

  useEffect(() => {
    if (!fileName || !shareLink) return;

    setRemainingSec(expiresIn * 60);

    const interval = setInterval(() => {
      setRemainingSec(prev => Math.max(0, prev - 1));
    }, 1000);

    return () => clearInterval(interval);
  }, [fileName, shareLink, expiresIn]);

  if (!fileName || !shareLink) return null;

  const formatTime = (sec) => {
    const minutes = Math.floor(sec / 60);
    const seconds = sec % 60;
    return `${minutes}:${seconds.toString().padStart(2, "0")}`;
  };

  const countdownClass =
    remainingSec === 0
      ? "time-expired"
      : remainingSec < 60
      ? "time-warning"
      : "time-ok";

  return (
    <Card className={`last-file-card ${isDark ? "dark" : "light"}`}>
      <h5 className="mb-2 fw-bold">Last Uploaded File</h5>

      <small className={countdownClass}>
        ⏳ Link expires in:{" "}
        {remainingSec > 0 ? formatTime(remainingSec) : "Expired"}
      </small>

      <div className="file-info mt-2">
        <div className="file-name" title={fileName}>
          <FaFileAlt /> {fileName}
        </div>

        <div className="d-flex gap-2">
          <Button
            variant={isDark ? "light" : "dark"}
            className="icon-button"
            onClick={onShareClick}
            title="Copy Link"
          >
            <FaClipboard />
          </Button>

          <Button
            variant={isDark ? "light" : "dark"}
            className="icon-button"
            onClick={() => window.open(shareLink, "_blank")}
            disabled={remainingSec <= 0}
            title={remainingSec > 0 ? "Download" : "Link expired"}
          >
            <FaDownload />
          </Button>
        </div>
      </div>
    </Card>
  );
};

export default LastUploadedFile;
